"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _SwarmPlot = require("./SwarmPlot.styled");

var _schemes = require("../schemes");

var _Theme = require("../Themes/Theme");

var _responsiveAxis = require("../Shared/responsiveAxis");

var _axisLabels = require("../Shared/axisLabels.enum");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["theme", "responsiveXaxisBottom", "responsiveYaxisLeft", "height", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SwarmPlot(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _Theme.StyledTheme : _ref$theme,
      _ref$responsiveXaxisB = _ref.responsiveXaxisBottom,
      responsiveXaxisBottom = _ref$responsiveXaxisB === void 0 ? {
    rotationBreakPoint: null,
    truncationCharLimit: 40,
    textWidth: 90
  } : _ref$responsiveXaxisB,
      _ref$responsiveYaxisL = _ref.responsiveYaxisLeft,
      responsiveYaxisLeft = _ref$responsiveYaxisL === void 0 ? {
    rotationBreakPoint: null,
    truncationCharLimit: 40,
    textWidth: 10
  } : _ref$responsiveYaxisL,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '500px' : _ref$height,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'swarmPlot' : _ref$id,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _jsxRuntime.jsx)("div", {
    id: id,
    style: {
      height: height,
      position: 'relative'
    },
    children: (0, _jsxRuntime.jsx)(_SwarmPlot.StyledSwarmPlot, _objectSpread(_objectSpread({}, props), {}, {
      theme: theme,
      colors: props.colors || _schemes.base,
      axisBottom: _objectSpread({
        renderTick: function renderTick(tick) {
          return (0, _responsiveAxis.responsiveAxis)(tick, document.querySelector("#".concat(id)), theme, _axisLabels.axisLabels.xBottom, responsiveYaxisLeft.rotationBreakPoint, responsiveYaxisLeft.truncationCharLimit, responsiveYaxisLeft.textWidth);
        }
      }, props.axisBottom)
    }))
  });
}

SwarmPlot.defaultProps = {};
SwarmPlot.displayName = 'SwarmPlot';
var _default = SwarmPlot;
exports["default"] = _default;